module.exports = __webpack_public_path__ + "static/media/aboutusheroimg.41d93502.png";